export function keepPopupInFocus() {
    if (this.popup && !this.popup.closed) {
        this.popup.focus();
    }
}
export function openNetsPopup(eIdProvider, netsState, nonce, netsDonePath, askForSsn, journey) {
    var width = 650;
    var height = 720;
    var x = window.outerWidth / 2 - width / 2 + window.screenX;
    var y = window.outerHeight / 2 - height / 2 + window.screenY;
    var clientId = "LYWKEWSJBUQT";
    var origin = window.location.origin;
    var netsDoneUri = "".concat(origin, "/").concat(netsDonePath[0] === "/" ? netsDonePath.slice(1) : netsDonePath);
    if (window.location.hostname === "localhost" &&
        window.location.port !== "3000") {
        console.error('');
        console.error("You need to run on localhost:3000 for Nets to work");
        console.error('');
    }
    var eidentUrl = encodeURI("".concat(process.env.REACT_APP_NETS, "/its/index.html") +
        "?client_id=".concat(clientId) +
        "&scope=openid+profile+cert".concat(askForSsn ? "+ssn" : "") +
        "&state=".concat(netsState) +
        "&nonce=".concat(nonce) +
        "&response_type=code" +
        "&redirect_uri=".concat(netsDoneUri) +
        (eIdProvider ? "&amr_values=".concat(eIdProvider) : ""));
    var popup = window.open(eidentUrl, "eident", "width=".concat(width, ",height=").concat(height, ",top=").concat(y, ",left=").concat(x));
    if (!popup) {
        journey === null || journey === void 0 ? void 0 : journey.transition("OPENING_POPUP", "noPopup");
    }
    else {
        journey === null || journey === void 0 ? void 0 : journey.transition("OPENING_POPUP", "created", eidentUrl);
    }
    keepPopupInFocus.prototype.popup = popup;
    window.addEventListener("focus", keepPopupInFocus);
    window.addEventListener("click", keepPopupInFocus);
    return popup;
}
